import { Typography, message, Input, Button, Row, Col, Space, DatePicker, Divider, Select, Card } from "antd";
import PageWrapper from "../../utils/PageWrapper";
import { PlusOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import PagosIndex from "./PagosIndex";
import AddPagoForm from "./AddPagoForm";
import axios from "axios";
import { useAuth } from "../../layout/auth";
import PagosOverview from "./PagosOverview";
import moment from "moment";
import PageTitle from "../../utils/PageTitle";
import { History } from "lucide-react";

export default function Pagos() {
  const [pagos, setPagos] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredPagos, setFilteredPagos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [agregarPagoVisible, setAgregarPagoVisible] = useState(false);
  const [editPagoVisible, setEditPagoVisible] = useState(false);
  const [pagoToEdit, setPagoToEdit] = useState(null);
  const [dateRange, setDateRange] = useState([moment().startOf("month"), moment().endOf("month")]);
  const [visibleColumns, setVisibleColumns] = useState([
    "Moneda",
    "T.C.",
    "Método",
    "Control Interno",
    "Folio Factura",
    "Referencia",
    "Notas",
  ]);

  const auth = useAuth();

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Pendiente";
      case 2:
        return "Confirmado";
      case 3:
        return "Cancelado";
      default:
        return "Desconocido";
    }
  };

  const handleEditPago = (record) => {
    setPagoToEdit(record);
    setEditPagoVisible(true);
  };

  useEffect(() => {
    setLoading(true);
    if (!dateRange) {
      setPagos([]);
      setLoading(false);
      return;
    }
    const [startDate, endDate] = dateRange;
    axios
      .get(`${process.env.REACT_APP_API_URL}/pagos`, {
        params: {
          u: auth.UID,
          startDate: startDate.format("YYYY-MM-DD"),
          endDate: endDate.format("YYYY-MM-DD"),
        },
      })
      .then((res) => {
        setPagos(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  }, [dateRange, auth.UID]);

  useEffect(() => {
    if (search) {
      const filtered = pagos.filter((pago) => {
        return (
          pago?.FacturaFolio?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.Monto?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.Moneda?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.Metodo?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.FechaPago?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.VerificacionID?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.ControlInterno?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.ReferenciaPago?.toString().toLowerCase().includes(search.toLowerCase()) ||
          pago?.Notas?.toString().toLowerCase().includes(search.toLowerCase()) ||
          getStatusText(pago?.Status).toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredPagos(filtered);
    } else {
      setFilteredPagos(pagos);
    }
  }, [search, pagos]);

  return (
    <PageWrapper className="pagos-main-card">
      <PageTitle icon={<History />} title="Historial de Pagos" />

      <div
        style={{
          padding: "16px",
          background: "rgba(249, 250, 251, 0.8)",
          borderRadius: "12px",
          border: "1px solid rgba(229, 231, 235, 0.6)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
          marginBottom: "24px",
        }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={12} md={8} lg={6}>
            <DatePicker.RangePicker value={dateRange} onChange={(dates) => setDateRange(dates)} style={{ width: "100%" }} />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Input.Search
              placeholder="Buscar pagos"
              onSearch={(value) => setSearch(value)}
              enterButton
              loading={loading}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={12} style={{ textAlign: "right" }}>
            <Space>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                size="large"
                onClick={() => setAgregarPagoVisible(true)}
                style={{
                  borderRadius: "8px",
                  height: "40px",
                }}
              >
                Agregar
              </Button>
            </Space>
          </Col>
        </Row>
        {/* <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Select
              mode="multiple"
              allowClear
              placeholder="Seleccionar columnas"
              defaultValue={visibleColumns}
              onChange={setVisibleColumns}
              maxTagCount={2}
              style={{ width: "100%" }}
            >
              <Select.Option key="Moneda" value="Moneda">
                Moneda
              </Select.Option>
              <Select.Option key="T.C." value="T.C.">
                Tipo de Cambio
              </Select.Option>
              <Select.Option key="Método" value="Método">
                Método
              </Select.Option>
              <Select.Option key="Control Interno" value="Control Interno">
                Control Interno
              </Select.Option>
              <Select.Option key="Folio Factura" value="Folio Factura">
                Folio Factura
              </Select.Option>
              <Select.Option key="Referencia" value="Referencia">
                Referencia
              </Select.Option>
              <Select.Option key="Notas" value="Notas">
                Notas
              </Select.Option>
            </Select>
          </Col>
        </Row> */}
      </div>
      <PagosOverview pagos={filteredPagos} />

      <PagosIndex
        pagos={filteredPagos}
        loading={loading}
        userRole={auth.Rol}
        handleEditPago={handleEditPago}
        visibleColumns={visibleColumns}
      />

      <AddPagoForm
        visible={agregarPagoVisible}
        setVisible={setAgregarPagoVisible}
        setPagos={setPagos}
        loading={loading}
        setLoading={setLoading}
      />
      <AddPagoForm
        visible={editPagoVisible}
        setVisible={setEditPagoVisible}
        setPagos={setPagos}
        loading={loading}
        setLoading={setLoading}
        initialValues={pagoToEdit}
      />
    </PageWrapper>
  );
}
